import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container, Typography, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        bgcolor: '#f5f5f5',
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            textAlign: 'center',
            bgcolor: 'white',
            borderRadius: 2,
            p: 6,
            boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          }}
        >
          <ErrorOutlineIcon
            sx={{
              fontSize: 120,
              color: '#29204C',
              mb: 3,
            }}
          />
          <Typography
            variant="h1"
            sx={{
              fontSize: '6rem',
              fontWeight: 700,
              color: '#29204C',
              mb: 2,
            }}
          >
            404
          </Typography>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 600,
              color: '#29204C',
              mb: 2,
            }}
          >
            Page Not Found
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: '#666',
              mb: 4,
            }}
          >
            The page you are looking for does not exist or has been moved.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button
              variant="contained"
              size="large"
              onClick={() => navigate('/')}
              sx={{
                bgcolor: '#29204C',
                '&:hover': {
                  bgcolor: '#1a1430',
                },
              }}
            >
              Go to Homepage
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={() => navigate(-1)}
              sx={{
                borderColor: '#29204C',
                color: '#29204C',
                '&:hover': {
                  borderColor: '#1a1430',
                  color: '#1a1430',
                },
              }}
            >
              Go Back
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default NotFound;
